// @ts-check
import React, { useState } from "react"
import useAikaTipsContext from "../contextConsumers/useAikaTipsContext.hook"
import useMount from "../useMount"
import { LS_CTRL_CLICK_TABLE_FILTER_TIP } from "../../consts/aikaTips.consts"

/** @type {import("./aikaTips.types.d.ts")["useCtrlClickTableTip"]} */
const useCtrlClickTableTip = () => {
  const {
    setMessage,
    isTipActive,
    setIsTipActive,
    showFAB: showFABContext,
    hideFAB: hideFABContext,
    setOnToastClose,
  } = useAikaTipsContext()

  const [completedTip, setCompletedTip] = useState(
    JSON.parse(localStorage.getItem(LS_CTRL_CLICK_TABLE_FILTER_TIP) || "false")
  )

  useMount(() => {
    setOnToastClose(() => () => {
      localStorage.setItem(LS_CTRL_CLICK_TABLE_FILTER_TIP, "true")
      setCompletedTip(true)
    })
  })

  function showFAB() {
    if (completedTip) return
    setMessage(
      <span>
        Usa <strong>Ctrl+Click</strong> en los valores de las columnas Proyecto,
        Integrante, Módulo y Categoría para filtrar más rápido.
      </span>
    )
    showFABContext()
  }

  function hideFAB() {
    hideFABContext()
  }

  function disableActiveTip() {
    setIsTipActive(false)
  }

  return { hideFAB, showFAB, isTipActive, disableActiveTip }
}

export default useCtrlClickTableTip
